import moment from "moment";

import { Popup } from "@/Common/Components/Modals/Popup";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { IPatientMedicalNoteModel } from "@/Patient/Models/UI/MedicalNote/IPatientMedicalNoteModel";

interface IPatientMedicalNoteAlreadySignedOffWarningProps {
    NoteModel: IPatientMedicalNoteModel;
}

class MedicalNoteAlreadySignedOffWarningPopup extends React.Component<IPatientMedicalNoteAlreadySignedOffWarningProps, any> {
    private id: string = "medicalnotealreadysignedoffwarningpopup";

    public componentDidMount(): void {
        overlayStore.showOverlay(this.id);
    }

    public componentWillUnmount(): void {
        overlayStore.hideOverlay(this.id);
    }

    public render(): JSX.Element {
        var signoffDate = this.props.NoteModel.get("AlreadySignedOffDate");
        var signoffById = this.props.NoteModel.get("AlreadySignedOffBy");
        var signoffBy = cacheStore.GetCliniciansPersonsByContactFacetId(signoffById);
        let signoffByName = (signoffBy != null) ? signoffBy.NameWithPrefix : "Id:" + signoffById;

        var title = cacheStore.GetString("WarningLabel");

        var msg = cacheStore.GetString("NoteAlreadySignedOff1Label");
        msg += " " + signoffByName + "(" + moment(signoffDate).format("YYYY-MM-DD HH:mm:SS") + " )";

        return (
            <Popup Id={this.id} title={title} closeTarget={LocalPatientOperations.MedicalNote.AlreadySignedOffWarningPopup_Ok} draggable={true} cssClass="memo">
                <div className="p-body">
                    <div>
                        <span> {msg} </span>
                    </div>
                </div>
                <div className="p-footer">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 columns text-right">
                            <div>
                                <div>
                                    <button className="btn btn-default" onClick={this.ContinueNoteClick.bind(this)}>{cacheStore.GetString("OKLabel")} </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Popup>
        );
    }

    private ContinueNoteClick(): void {
        var operation = new LocalEvent(LocalPatientOperations.MedicalNote.AlreadySignedOffWarningPopup_Ok);
        LocalEventDispatcher.dispatch(operation);
    }
}

export { MedicalNoteAlreadySignedOffWarningPopup };
